import { useTranslation } from 'react-i18next';

export interface ApiError {
  message: string;
  status?: number;
}

/**
 * Detects if an error is a fetch/network error
 */
export const isFetchError = (error: any): boolean => {
  if (!error) return false;
  
  const errorMessage = error.message?.toLowerCase() || '';
  const errorName = error.name?.toLowerCase() || '';
  
  return (
    errorName === 'typeerror' ||
    errorName === 'networkerror' ||
    errorMessage.includes('failed to fetch') ||
    errorMessage.includes('network error') ||
    errorMessage.includes('fetch') ||
    error instanceof TypeError
  );
};

/**
 * Hook that provides error handling utilities
 */
export const useErrorHandler = () => {
  const { t } = useTranslation();
  
  const handleApiError = (error: any): ApiError => {
    if (isFetchError(error)) {
      return { message: t('errors.fetchError') };
    }
    
    if (error instanceof Error) {
      if (error.message === 'SESSION_EXPIRED') {
        return { message: '', status: 401 };
      }
      return { message: error.message };
    }
    
    return { message: t('errors.unknownError') };
  };
  
  return { handleApiError, isFetchError };
};
